import React from 'react';
import {Observer} from "mobx-react-lite";
import ProfitsTabProperties from './ProfitsTabProperties';
import { useStyles } from './ProfitsTab.style';
import ArticleTab from './ArticleTab/ArticleTab';
import TabOption from '../../../ui_components/Tab/TabOption';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import FastfoodIcon from '@mui/icons-material/Fastfood';
import SendToMobileIcon from "@mui/icons-material/SendToMobile";
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import Tabs from '../../../ui_components/Tab/Tabs';
import MiscellanyTab from './MiscellanyTab/MiscellanyTab';
import MoneyTab from './MoneyTab/MoneyTab';
import PackageTab from './PackageTab/PackageTab';
import TopupTab from './TopupTab/TopupTab';
import ShopTab from './ShopTab/ShopTab';
import { Inventory } from '@mui/icons-material';

const ProfitsTab: React.FC<ProfitsTabProperties> = ({
    from,
    to
}) => {

    const classes = useStyles();

    const tabsContent = [
        new TabOption("Envío", <MoneyTab from={from} to={to}/>, <AttachMoneyIcon/>),
        new TabOption("Artículo", <ArticleTab from={from} to={to}/>, <FastfoodIcon/>),
        new TabOption("Paquete", <PackageTab from={from} to={to}/>, <Inventory/>),

        new TabOption("Recarga", <TopupTab from={from} to={to}/>, <SendToMobileIcon/>),
        new TabOption("Miscelánea", <MiscellanyTab from={from} to={to}/>, <DashboardCustomizeIcon/>),
        new TabOption("Tienda", <ShopTab from={from} to={to}/>, <ShoppingCartIcon/>),
    ];

    return <Observer>
        {() => (<div className={classes.tab_container}>
            <div className={classes.row}>                
                <div>
                    <Tabs content={tabsContent}/>
                </div>
            </div>
        </div>)}
    </Observer>
}

export default ProfitsTab;
